import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/async-processes`;

export const {
  useGetAll: useAllAsyncProcesses,
  useCreate: useCreateAsyncProcesses,
} = apiCrudBuilder(path, "AsyncProcesses");

export const useRetryAsyncProcess = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);
  return useMutation({
    ...options,
    mutationFn: (data) => {
      appAxios.post(`${path}/`, data).then((res) => res.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all_AsyncProcesses"] });
    },
  });
};
